/*
 * bugs-quick-add-fix.js
 * -------------------------------------------------------------------------
 * Problem it solves:
 * The product card "cart mark" uses <form is="product-form"> (a *customized
 * built-in* element, extends: "form"). On some browsers/situations (notably
 * iOS Safari) that upgrade does not attach, so the form does a NATIVE POST to
 * /cart/add and the browser navigates to /cart -> it looks like "the page just
 * reloads and nothing is added".
 *
 * This handler guarantees the single-variant card add always runs as a proper
 * AJAX add, faithfully reproducing the theme's own ProductForm._onSubmit flow
 * (same events, same mini-cart open/refresh behaviour). It is scoped ONLY to
 * card quick-add forms (.product-item__quick-form) so the main product page
 * form is left completely untouched.
 *
 * Double-add safe: it runs in the capture phase and calls
 * stopImmediatePropagation(), so if the native ProductForm handler *is* active
 * it never also fires. Exactly one add happens on every browser.
 */
(function () {
  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function addUrl() {
    var r = (window.themeVariables && window.themeVariables.routes) || {};
    return (r.cartAddUrl || (root() + 'cart/add')) + '.js';
  }
  function cartUrl() {
    var r = (window.themeVariables && window.themeVariables.routes) || {};
    return (r.cartUrl || (root() + 'cart')) + '.js';
  }
  function settings() {
    return (window.themeVariables && window.themeVariables.settings) || {};
  }

  async function quickAdd(form) {
    var buttons = Array.prototype.slice.call(form.querySelectorAll('[type="submit"]'));
    buttons.forEach(function (b) {
      b.setAttribute('disabled', 'disabled');
      b.setAttribute('aria-busy', 'true');
    });

    try {
      var data = new FormData(form);
      data.append('sections', ['mini-cart']);
      data.delete('option1');
      data.delete('option2');
      data.delete('option3');

      var response = await fetch(addUrl(), {
        method: 'POST',
        body: data,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      var json = await response.json();

      buttons.forEach(function (b) {
        b.removeAttribute('disabled');
        b.removeAttribute('aria-busy');
      });

      if (response.ok) {
        var s = settings();
        // Match theme behaviour: on the cart page / cart-as-page, reload to /cart.
        if (s.cartType === 'page' || s.pageType === 'cart') {
          window.location.href = root() + 'cart';
          return;
        }

        form.dispatchEvent(new CustomEvent('variant:added', {
          bubbles: true,
          detail: { variant: json.hasOwnProperty('items') ? json['items'][0] : json }
        }));

        var cartResponse = await fetch(cartUrl());
        var cart = await cartResponse.json();

        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: cart }
        }));

        cart['sections'] = json['sections'];
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: {
            cart: cart,
            // Open the mini-cart drawer unless we're already inside a drawer.
            openMiniCart: s.cartType === 'drawer' && form.closest('.drawer') === null
          }
        }));
      } else {
        form.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }

      form.dispatchEvent(new CustomEvent('cart-notification:show', {
        bubbles: true,
        cancelable: true,
        detail: {
          status: response.ok ? 'success' : 'error',
          error: (json && json['description']) || ''
        }
      }));
    } catch (error) {
      buttons.forEach(function (b) {
        b.removeAttribute('disabled');
        b.removeAttribute('aria-busy');
      });
      console.error('[bugs-quick-add-fix] add failed:', error);
    }
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.nodeName !== 'FORM') return;
    if (!form.classList.contains('product-item__quick-form')) return;

    // Take over from the (possibly non-upgraded) native form handler.
    event.preventDefault();
    event.stopImmediatePropagation();
    quickAdd(form);
  }, true); // capture phase -> runs before the form's own submit listener
})();

/*
 * View-cart link fix
 * -------------------------------------------------------------------------
 * The green "added to cart" notification's "カートを見る" link normally opens
 * the #mini-cart drawer, but when the add happened from inside a quick-buy
 * popover/drawer the mini-cart opened *behind* it (looked like nothing
 * happened). Navigating to /cart instead 404s inside the theme preview
 * (a hard navigation drops the preview session).
 *
 * So: close any open quick-buy popover/drawer first, then open the mini-cart
 * drawer in place -- no navigation, works in preview AND production. Falls back
 * to the cart page only when there is no drawer (cart-type = page).
 */
(function () {
  function cartUrl() {
    var r = (window.themeVariables && window.themeVariables.routes) || {};
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.cartUrl || (root + 'cart');
  }

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;
    var link = t.closest('[data-action="view-cart"], .cart-notification__view-cart');
    if (!link) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    // 1) Close any open quick-buy popover/drawer so the mini-cart is not hidden behind it.
    var popups = document.querySelectorAll('quick-buy-drawer, quick-buy-popover');
    for (var i = 0; i < popups.length; i++) {
      try { popups[i].open = false; } catch (e) {}
    }

    // 2) Hide the notification itself.
    var note = t.closest('cart-notification');
    if (note) { try { note.hidden = true; } catch (e) {} }

    // 3) Open the mini-cart drawer in place, after the popover has begun closing.
    var mc = document.getElementById('mini-cart');
    if (mc) {
      setTimeout(function () {
        try { mc.open = true; }
        catch (e) { window.location.href = cartUrl(); }
      }, 180);
    } else {
      // No drawer (cart-type = page): going to the cart page is the correct behaviour.
      window.location.href = cartUrl();
    }
  }, true); // capture phase -> runs before the theme's own view-cart handler
})();
